// extracted by mini-css-extract-plugin
export default {"CatalogContent":"CatalogContent_CatalogContent__wnvJs","Index":"CatalogContent_Index__BmwcL","Content":"CatalogContent_Content__0z4Mj"};